/**
 * MockDataBanner Component
 * 
 * Displays a prominent banner at the top of the page when mock data mode is enabled.
 * This helps developers know they're viewing simulated data, not production API data.
 */

import { useMockData } from '../lib/api/mockService';

export default function MockDataBanner() {
  const isMockMode = useMockData();
  
  if (!isMockMode) {
    return null;
  }
  
  return (
    <div className="bg-amber-400 border-b-2 border-amber-500 px-4 py-2 text-center text-sm font-medium text-amber-900 shadow-sm">
      <span className="inline-flex items-center gap-2">
        <svg 
          className="h-4 w-4" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
          />
        </svg>
        <span>
          <strong>Mock Data Mode:</strong> Viewing simulated data for development/testing.
          Set <code className="bg-amber-500 px-1 rounded">VITE_USE_MOCK_DATA=false</code> to use real API.
        </span>
      </span>
    </div>
  );
}
